import { useEffect, useState } from 'react';
import axios from 'axios';

const API = ((typeof window !== "undefined" && window.__API_URL__) || process.env.REACT_APP_BACKEND_URL) + '/api';

/** Hook for fetching billing status (cached for 60s in module scope to avoid spam). */
let _cache = null;
let _cacheTime = 0;
const CACHE_MS = 60_000;

export function useBillingStatus(enabled = true) {
  const [billing, setBilling] = useState(_cache);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    if (!enabled) return;
    const now = Date.now();
    if (_cache && now - _cacheTime < CACHE_MS) {
      setBilling(_cache);
      setLoading(false);
      return;
    }
    let cancelled = false;
    axios.get(`${API}/billing/status`, { withCredentials: true })
      .then((r) => {
        if (cancelled) return;
        _cache = r.data;
        _cacheTime = Date.now();
        setBilling(r.data);
      })
      .catch(() => {
        if (cancelled) return;
        // En cas d'erreur, par sécurité on autorise l'accès (évite blocage par bug réseau)
        _cache = { can_access: true, _error: true };
        setBilling(_cache);
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [enabled]);

  return { billing, loading, refresh: () => { _cache = null; _cacheTime = 0; } };
}
